import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export default function BrandMetricsGrid({ brand }) {
  if (!brand) return null;
  
  const metrics = [
    { value: brand.overall_brand_score, label: 'Overall Score', isPrimary: true },
    { value: brand.brand_strength_index, label: 'Brand Strength' },
    { value: brand.commercial_attractiveness, label: 'Commercial' },
    { value: brand.global_recognition, label: 'Global' },
    { value: brand.tournament_performance_factor, label: 'Tournament' },
  ];
  
  return (
    <div className="grid md:grid-cols-5 gap-4">
      {metrics.map((m, i) => (
        <Card key={i} className="bg-card">
          <CardContent className="pt-6 text-center">
            <p className={`text-4xl font-bold ${m.isPrimary ? 'text-primary' : ''}`}>{m.value}</p>
            <p className="text-sm text-muted-foreground">{m.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
